module.exports = __webpack_public_path__ + "assets/img/hxjzl_title.9140c848.png";